import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel } from '../../../redux/DefaultModelActions';

const model = 'NetworkContent';
const route = '/v1/networkcontent';

export const searchNetworkContent = (page, limit, search, view) => searchModels(model, route, page, limit, search, view);
export const createNetworkContent = (args) => createModel(model, route, args);
export const updateNetworkContent = (id, args) => updateModel(model, route, id, args);
export const deleteNetworkContent = (id) => deleteModel(model, route, id);
export const restoreNetworkContent = (id) => restoreModel(model, route, id);
export const getNetworkContent = (id) => getModel(model, route, id);
export const getNetworkContentRevision = (id) => getRevisions(model, route, id);
export const duplicateNetworkContent = (id) => duplicateModel(model, route, id);